import { useSelector } from "react-redux";
import { selectUser, selectUserEmail, selectTempProfilePictureURL } from "../../store/userSlice";
import { useNavUtils } from "../../utils/navUtils";
import config from "../../utils/config";
import UserWidget from "./UserWidgetView";

export default function UserWidgetContainer() {
  if (!config.showUserLoginStatus) {
    return null;
  }

  const { logoutReset, goNav, getLoginTarget } = useNavUtils();
  const reduxUser = useSelector(selectUser);
  const userEmail = useSelector(selectUserEmail);
  const tempProfilePictureURL = useSelector(selectTempProfilePictureURL);

  const handleLogout = async () => {
    const loginTarget = getLoginTarget();
    await logoutReset();
    goNav(loginTarget);
  };

  const getUserName = () => {
    const firstName = reduxUser?.name?.first_name || "";
    const lastName = reduxUser?.name?.last_name || "";
    return `${firstName} ${lastName}`.trim();
  };

  return (
    <UserWidget
      name={getUserName()}
      email={userEmail || undefined}
      imageUrl={tempProfilePictureURL || undefined}
      onLogout={handleLogout}
    />
  );
}
